var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z",
    fill: "#FDE047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 16.3C11.6307 16.3 12.75 15.1808 12.75 13.8C12.75 12.4193 11.6307 11.3 10.25 11.3C8.86929 11.3 7.75 12.4193 7.75 13.8C7.75 15.1808 8.86929 16.3 10.25 16.3Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 16.3C23.1307 16.3 24.25 15.1808 24.25 13.8C24.25 12.4193 23.1307 11.3 21.75 11.3C20.3693 11.3 19.25 12.4193 19.25 13.8C19.25 15.1808 20.3693 16.3 21.75 16.3Z",
    fill: "#664E27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4498 24H12.5498C11.7998 24 11.7998 22 12.5498 22H19.3998C20.1998 22 20.1998 24 19.4498 24Z",
    fill: "#664E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji3);
export default __webpack_public_path__ + "static/media/emoji_3.6a6552b87caa2dad34dd8fef6bb91cce.svg";
export { ForwardRef as ReactComponent };